//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VClamp from 'vue-clamp'

export default {
  components: {
    VClamp
  },

  props: {
    medias: {
      type: Array,
      default: () => {
        return []
      }
    },

    slidesToShow: {
      type: Number,
      default: 4
    },

    thumbHeight: {
      type: Number,
      default: 65
    }
  },

  data() {
    return {
      show: false,
      galleryOptions: {
        arrows: false,
        dots: false,
        infinite: true,
        fade: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        asNavFor: this.$refs.thumbnails,
        focusOnSelect: true
      },
      thumbnailsOptions: {
        slidesToShow: this.slidesToShow,
        arrows: true,
        dots: false,
        infinite: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        asNavFor: this.$refs.gallery,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.show = true
    }, 300)
  },

  methods: {
    onBeforeChangeGallery(currentPosition, nextPosition) {
      this.$refs.thumbnails.goTo(nextPosition)
    },

    onBeforeChangeThumbnails(currentPosition, nextPosition) {
      this.$refs.gallery.goTo(nextPosition)
      if (this.$refs['media-' + currentPosition]) {
        this.$refs['media-' + currentPosition].contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        )
      }
    }
  }
}
